module.exports = __webpack_public_path__ + "img/serbia.ad757b9.webp";